import React, { useState } from 'react';
import { useTheme } from 'styled-components';
import { useTranslate } from '@/translations';
import { Title, faMapMarkerAlt, PageContainer, Map } from '@/ui/components';
import { useVinMovements, useVinPositions } from '@/api/Vin';
import { Card, Col, Row, Spin } from 'antd';
import { VinDataGrid } from './components/VinDataGrid';

export const Vin = () => {
  const [selectedVin, setSelectedVin] = useState<string | undefined>();
  const { t } = useTranslate();
  const { vinLink } = useTheme();
  const { data, isFetching } = useVinMovements();
  const { data: vinPositionsData } = useVinPositions(selectedVin);

  return (
    <PageContainer>
      <Title title={t('vinTracking')} icon={faMapMarkerAlt} color={vinLink} />
      <Spin spinning={isFetching}>
        <Row gutter={16}>
          <Col lg={12} sm={24}>
            <Card className="h-100" styles={{ body: { height: '100%' } }}>
              <VinDataGrid
                dataSource={data?.entities}
                onSelectVin={setSelectedVin}
              />
            </Card>
          </Col>
          <Col lg={12} sm={24}>
            <Card
              className="h-100"
              styles={{ body: { height: '100%', minHeight: 500 } }}
            >
              <Map
                markers={vinPositionsData?.entities?.map(({ lat, lon }) => ({
                  lat: Number(lat),
                  lng: Number(lon),
                }))}
              />
            </Card>
          </Col>
        </Row>
      </Spin>
    </PageContainer>
  );
};
